import { render, staticRenderFns } from "./MessageTypeMessage.vue?vue&type=template&id=750fd7da&scoped=true&"
import script from "./MessageTypeMessage.vue?vue&type=script&lang=js&"
export * from "./MessageTypeMessage.vue?vue&type=script&lang=js&"
import style0 from "./MessageTypeMessage.vue?vue&type=style&index=0&id=750fd7da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750fd7da",
  null
  
)

export default component.exports